<template>
	<div class="share-dialog-inner-title">{{ text }}</div>
</template>
<script>
export default {
	name: 'ShareFeatureDialogInnerTitle',
	props: { text: { type: String, required: true } },
};
</script>
<style scoped lang="scss">
.share-dialog-inner-title {
	font-size: 18px;
	font-weight: 600;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}
</style>
